export function scrollToTop(behavior: ScrollBehavior = "smooth") {
  window.scrollTo({ top: 0, behavior });
}

/**
 * Generic scroll-threshold binder. Fires `onChange` with the current
 * past/under-threshold state, immediately and on every scroll.
 * Returns an unsubscribe function.
 */
export function bindScrollThreshold(
  onChange: (isPastThreshold: boolean) => void,
  { threshold = 10 }: { threshold?: number } = {},
) {
  const onScroll = () => onChange(window.scrollY > threshold);
  window.addEventListener("scroll", onScroll, { passive: true });
  onScroll(); // set initial state
  return () => window.removeEventListener("scroll", onScroll);
}

/** Toggles a shadow class on/off a border class as the page scrolls past `threshold`. */
export function bindScrollShadow(
  el: HTMLElement,
  {
    threshold = 10,
    shadowClassName = "shadow-sticky-bar",
    borderClassName = "border-b",
  }: {
    threshold?: number;
    shadowClassName?: string;
    borderClassName?: string;
  } = {},
) {
  return bindScrollThreshold(
    (scrolled) => {
      el.classList.toggle(shadowClassName, scrolled);
      el.classList.toggle(borderClassName, !scrolled);
    },
    { threshold },
  );
}

/** Toggles visibility (via a hidden class) for things like a "back to top" button. */
export function bindScrollVisibility(
  el: HTMLElement,
  {
    threshold = 10,
    hiddenClassName = "hidden",
  }: { threshold?: number; hiddenClassName?: string } = {},
) {
  return bindScrollThreshold(
    (scrolled) => el.classList.toggle(hiddenClassName, !scrolled),
    { threshold },
  );
}